// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const FitContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  min-width: 100%;
  border-bottom: 1px solid #979797;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FitButton = styled.button`
  display: flex;
  color: #000;
  text-align: center;
  text-decoration: none;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: 0;
  background: white;
  border-bottom: ${(props) => (props.active ? '2px solid #000' : '0')};
  padding: 10px;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: 5px;
  }
  transition: all 0.3s ease;
`;
